import React, { Component } from 'react';
import { Waypoint } from 'react-waypoint';
import * as Scroll from 'react-scroll';
import Media from 'react-media';
import withClickAnalytics from '../../enchancers/with-click-analytics';
import { AnalyticsConsumer } from '../../providers/AnalyticsProvider';
import ScreenSection from '../screen-section/ScreenSection';
import ContentContainer from '../content-container/ContentContainer';
import SectionTitle from '../section-title/SectionTitle';
import Button from '../button/Button';
import MainSlider from '../main-slider/MainSlider';

import journalistsBackgroundImage from './assets/partnership-bg-4.jpg';

import slide1 from './assets/1.png';
import slide1x2 from './assets/1@2x.png';
import slide2 from './assets/2.png';
import slide2x2 from './assets/2@2x.png';
import slide3 from './assets/3.jpg';
import slide3x2 from './assets/3@2x.jpg';

import styles from './ForJournalistsScreen.module.scss';

const TrackedButton = withClickAnalytics({
  category: 'infographic',
  defaultAction: 'btn_click',
})(Button);

class ForJournalistsScreen extends Component {
  state = {
    currentSlidePage: 0,
  };

  isSliderInViewport = false;
  isViewed = false;

  handleSliderEnterViewport = (sendAction) => () => {
    const { currentSlidePage } = this.state;
    this.isSliderInViewport = true;
    sendAction('data', currentSlidePage);
  };

  handleSliderLeaveViewport = () => () => {
    this.isSliderInViewport = false;
  };

  handleSlideChange = (sendAction) => ({ page, count }) => {
    if (page < 0 || page > count - 1) {
      return;
    }

    this.setState({
      currentSlidePage: page,
    });

    if (this.isSliderInViewport) {
      sendAction('data', page);
    }
  };

  render() {
    const { id } = this.props;
    return (
      <ScreenSection id={id} theme="dark" background={journalistsBackgroundImage}>
        <ContentContainer width="narrow">
          <Media query="(max-width: 960px)">
            {(isMobile) => (
              <div className={styles.root}>
                <div className={styles.leftCol}>
                  <SectionTitle>
                    for
                    <br />
                    jour-
                    <br />
                    nalists
                  </SectionTitle>
                  <p className={styles.description}>
                    Are you looking for a qualitative content for your next article or real estate
                    market research?
                    <br />
                    For now, we can provide you such information:
                    <br />
                    median rents and sales prices by property type and by bedroom number in each
                    region of the country; price dynamics per month.
                  </p>
                  {!isMobile && (
                    <div className={styles.actionHolder}>
                      <TrackedButton component={Scroll.Link} to="contacts" smooth>
                        I want free data
                      </TrackedButton>
                    </div>
                  )}
                </div>

                <div className={styles.rightCol}>
                  <div className={styles.slider}>
                    <AnalyticsConsumer category="infographic">
                      {({ sendAction, dataProps }) => (
                        <Waypoint
                          onEnter={this.handleSliderEnterViewport(sendAction)}
                          onLeave={this.handleSliderLeaveViewport(sendAction)}
                        >
                          <MainSlider {...dataProps} onChange={this.handleSlideChange(sendAction)}>
                            <MainSlider.Item>
                              <img
                                className={styles.siteImage}
                                src={slide1}
                                srcSet={`${slide1x2} 2x`}
                                alt=""
                              />
                            </MainSlider.Item>
                            <MainSlider.Item>
                              <img
                                className={styles.siteImage}
                                src={slide2}
                                srcSet={`${slide2x2} 2x`}
                                alt=""
                              />
                            </MainSlider.Item>
                            <MainSlider.Item>
                              <img
                                className={styles.siteImage}
                                src={slide3}
                                srcSet={`${slide3x2} 2x`}
                                alt=""
                              />
                            </MainSlider.Item>
                          </MainSlider>
                        </Waypoint>
                      )}
                    </AnalyticsConsumer>
                  </div>
                </div>
                {isMobile && (
                  <div className={styles.actionHolder}>
                    <TrackedButton component={Scroll.Link} to="contacts" smooth>
                      I want free data
                    </TrackedButton>
                  </div>
                )}
              </div>
            )}
          </Media>
        </ContentContainer>
      </ScreenSection>
    );
  }
}

export default ForJournalistsScreen;
